import { configureStore } from '@reduxjs/toolkit'

import productsReducer from './AllSlices/products'
import categoriesReducer from './AllSlices/categories'
import reviewsReducer from './AllSlices/reviewsSlice'
import authReducer from "./AllSlices/auth"
import addressReducer from "./AllSlices/addressSlice"
import ordersReducer from "./AllSlices/orderSlice"
import bannersReducer from './AllSlices/homeSlider'
import blogsReducer from './AllSlices/blogs'

export default configureStore({
    reducer: {
        products: productsReducer,
        categories: categoriesReducer,
        reviewsdata: reviewsReducer,
        auth: authReducer,
        addresses: addressReducer,
        ordersData: ordersReducer,
        bannersData: bannersReducer,
        blogs: blogsReducer,
    }
})